import { Outlet } from "react-router";

const GiftSetupIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default GiftSetupIndexPage;
